/**
 * Delivery ETA — native custom element
 * Replaces SetubridgeApps "Delivery Date ETA" app.
 * ~250 lines, vanilla JS, 0 dependencies.
 */

(() => {
  /* ── Transit days by country code ── */
  const TRANSIT = {
    FR: { express: 1, standard: 2 },
    /* Zone 1 — J+1 */
    BE:1,DE:1,IT:1,ES:1,LU:1,PT:1,IE:1,DK:1,CZ:1,LI:1,MC:1,VA:1,
    BH:1,BD:1,ET:1,IR:1,JO:1,KW:1,MU:1,OM:1,QA:1,SA:1,LK:1,AE:1,
    /* Zone 2 — J+2 */
    GB:2,CH:2,NL:2,AT:2,PL:2,SE:2,FI:2,NO:2,IS:2,AD:2,BG:2,HR:2,CY:2,
    EE:2,GR:2,HU:2,LV:2,LT:2,MT:2,RO:2,SK:2,SI:2,AL:2,BA:2,GG:2,JE:2,
    XK:2,MK:2,MD:2,ME:2,SM:2,RS:2,TR:2,AM:2,AU:2,BW:2,MM:2,BI:2,KH:2,
    CA:2,CN:2,DJ:2,EG:2,GI:2,HK:2,IN:2,ID:2,JP:2,KE:2,KR:2,LB:2,LS:2,
    MO:2,MY:2,MV:2,MA:2,MZ:2,NA:2,NG:2,PK:2,PH:2,PR:2,RU:2,SG:2,ZA:2,
    SD:2,SS:2,SZ:2,TW:2,TZ:2,TH:2,UG:2,US:2,VN:2,YE:2,ZM:2,
    /* Zone 3 — J+3 */
    AF:3,DZ:3,AO:3,AI:3,AR:3,AZ:3,BS:3,BB:3,BY:3,BZ:3,BJ:3,BM:3,BT:3,
    BR:3,BN:3,KY:3,CL:3,CO:3,KM:3,CG:3,CD:3,CR:3,CW:3,EC:3,SV:3,ER:3,
    FK:3,FO:3,GA:3,GE:3,GH:3,GL:3,GT:3,GN:3,HT:3,HN:3,CI:3,JM:3,KZ:3,
    LA:3,LR:3,MG:3,MW:3,ML:3,MX:3,NP:3,NZ:3,NI:3,PA:3,PY:3,RW:3,WS:3,
    SN:3,SC:3,SL:3,TG:3,TT:3,TN:3,TC:3,UA:3,UY:3,VG:3,VI:3,ZW:3,
    /* Zone 4 — J+4 */
    AS:4,AG:4,AW:4,BO:4,BQ:4,BF:4,CM:4,CV:4,DM:4,DO:4,TL:4,GQ:4,FJ:4,
    GM:4,GD:4,GU:4,GY:4,IQ:4,KG:4,MR:4,FM:4,MS:4,KN:4,NE:4,PW:4,PG:4,
    PE:4,SH:4,ST:4,SX:4,LC:4,MF:4,VC:4,SR:4,SY:4,TJ:4,UZ:4,VE:4,
    /* Zone 5 — J+5 */
    CF:5,TD:5,CK:5,CU:5,GW:5,KI:5,KP:5,LY:5,MH:5,MN:5,NR:5,NU:5,
    SB:5,SO:5,TO:5,TV:5,VU:5
  };

  const DOM_TOM = new Set(['GP','MQ','GF','RE','YT','PM','BL','WF','PF','NC']);
  const NO_FLAG = new Set(['FR','GB','US','CA']);
  const EU_COUNTRIES = new Set([
    'FR','BE','DE','IT','ES','LU','PT','IE','DK','CZ','LI','MC','VA',
    'GB','CH','NL','AT','PL','SE','FI','NO','IS','AD','BG','HR','CY',
    'EE','GR','HU','LV','LT','MT','RO','SK','SI','AL','BA','GG','JE',
    'XK','MK','MD','ME','SM','RS','TR'
  ]);

  const DOM_TOM_NAMES = {
    GP:'Guadeloupe',MQ:'Martinique',GF:'Guyane française',RE:'La Réunion',
    YT:'Mayotte',PM:'Saint-Pierre-et-Miquelon',BL:'Saint-Barthélemy',
    WF:'Wallis-et-Futuna',PF:'Polynésie française',NC:'Nouvelle-Calédonie'
  };

  /* ── Translations ── */
  const I18N = {
    fr: {
      delivered_by: 'Livraison le :',
      tomorrow: '<strong style="color:#047857">demain</strong> avant 13h (Chronopost)',
      express: '{date} (Chronopost)',
      standard: '{date} (Standard Gratuit)',
      dhl_delivery: 'Livraison le {date} avec DHL',
      domtom_range: '{name} — Livraison entre le {min} et le {max}',
      intl_range: 'Livraison entre le {min} et le {max} avec DHL',
      preorder: 'Pièce en précommande.\nLivraison prévue le {date}',
      artisanal: '✨ Création artisanale sur commande\nLivraison prévue entre le {min} et le {max}\n<em style="font-size:0.9em;opacity:0.75">Pour toute urgence, écrivez-nous à <a href="mailto:bonjour@mayuri.fr" style="color:inherit;text-decoration:underline">bonjour@mayuri.fr</a></em>',
      gold_oos_dhl: 'Livraison le {date} avec DHL',
      gold_oos_domtom: '{name} — Livraison entre le {min} et le {max}',
      gold_delivered_by: 'En stock, livraison le :',
      gold_dhl_delivery: 'En stock, livraison le {date} avec DHL',
      property_label: 'Livraison'
    },
    en: {
      delivered_by: 'Delivered by:',
      tomorrow: '<strong>tomorrow</strong> before 1pm (Express)',
      express: '{date} (Express)',
      standard: '{date} (Standard — Free)',
      dhl_delivery: 'Delivery by {date} with DHL',
      domtom_range: '{name} — Delivery between {min} and {max}',
      intl_range: 'Delivery between {min} and {max} with DHL',
      preorder: 'Pre-order item.\nExpected delivery by {date}',
      artisanal: '✨ Artisanal creation made to order\nExpected delivery between {min} and {max}\n<em style="font-size:0.9em;opacity:0.75">For any urgent request, contact us at <a href="mailto:bonjour@mayuri.fr" style="color:inherit;text-decoration:underline">bonjour@mayuri.fr</a></em>',
      gold_oos_dhl: 'Delivery by {date} with DHL',
      gold_oos_domtom: '{name} — Delivery between {min} and {max}',
      gold_delivered_by: 'In stock, delivered by:',
      gold_dhl_delivery: 'In stock, delivery by {date} with DHL',
      property_label: 'Delivery'
    },
    es: {
      delivered_by: 'Entrega prevista:',
      tomorrow: '<strong>mañana</strong> antes de las 13h (Express)',
      express: '{date} (Express)',
      standard: '{date} (Estándar — Gratis)',
      dhl_delivery: 'Entrega el {date} con DHL',
      domtom_range: '{name} — Entrega entre el {min} y el {max}',
      intl_range: 'Entrega entre el {min} y el {max} con DHL',
      preorder: 'Artículo en pre-orden.\nEntrega prevista el {date}',
      artisanal: '✨ Creación artesanal bajo pedido\nEntrega prevista entre el {min} y el {max}\n<em style="font-size:0.9em;opacity:0.75">Para cualquier urgencia, escríbenos a <a href="mailto:bonjour@mayuri.fr" style="color:inherit;text-decoration:underline">bonjour@mayuri.fr</a></em>',
      gold_oos_dhl: 'Entrega el {date} con DHL',
      gold_oos_domtom: '{name} — Entrega entre el {min} y el {max}',
      gold_delivered_by: 'En stock, entrega prevista:',
      gold_dhl_delivery: 'En stock, entrega el {date} con DHL',
      property_label: 'Entrega'
    }
  };

  /* ── Country resolution ──
     Shopify ne géolocalise PAS les visiteurs du .com : toute session
     vierge reçoit le pays par défaut du domaine, Bermudes. En temps
     normal snippets/auto-localize.liquid a déjà basculé la session vers
     le pays dérivé du fuseau du device (devise locale comprise) avant
     d'arriver ici. Ce fallback couvre le premier rendu et les cas où le
     POST /localization a échoué : même dérivation, via la table
     window.__mayuriTzCountry posée par le snippet (source unique).
     Fuseau non livrable ou inconnu → US, le rendu générique du .com.
     Un vrai Bermudien (Atlantic/Bermuda) garde BM ; un pays choisi au
     sélecteur (≠ BM) n'est jamais réécrit. */
  function resolveCountry(cc) {
    if (cc !== 'BM') return cc;
    let tz = '';
    try { tz = Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (e) { /* pas d'Intl */ }
    if (tz === 'Atlantic/Bermuda') return cc;
    return (window.__mayuriTzCountry || {})[tz] || 'US';
  }

  /* Transporteur affiché : DHL partout, sauf exceptions par pays. */
  const CARRIER_OVERRIDE = { AE: 'FedEx' };

  /* ── Country flag emoji ── */
  function flag(cc) {
    if (NO_FLAG.has(cc)) return '';
    return String.fromCodePoint(...[...cc.toUpperCase()].map(c => 0x1F1E6 + c.charCodeAt(0) - 65));
  }

  /* ── French public holidays ── */
  function easterSunday(year) {
    const a = year % 19, b = Math.floor(year / 100), c = year % 100;
    const d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4), k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31) - 1;
    const day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(year, month, day);
  }

  function frenchHolidays(year) {
    const easter = easterSunday(year);
    const addDays = (d, n) => { const r = new Date(d); r.setDate(r.getDate() + n); return r; };
    return [
      new Date(year, 0, 1), new Date(year, 4, 1), new Date(year, 4, 8),
      new Date(year, 6, 14), new Date(year, 7, 15), new Date(year, 10, 1),
      new Date(year, 10, 11), new Date(year, 11, 25),
      addDays(easter, 1), addDays(easter, 39), addDays(easter, 50)
    ].map(d => d.toISOString().slice(0, 10));
  }

  /* ── Date helpers ── */
  function addBusinessDays(start, days, { shipDays, holidays }) {
    const d = new Date(start);
    let added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      const dow = d.getDay();
      const iso = d.toISOString().slice(0, 10);
      if (dow === 0) continue; // Sunday always excluded
      if (shipDays === 'mon-fri' && dow === 6) continue; // Saturday excluded for dispatch
      if (holidays.has(iso)) continue;
      added++;
    }
    return d;
  }

  function nowInTz(tz) {
    const s = new Date().toLocaleString('en-CA', { timeZone: tz, hour12: false });
    const [datePart, timePart] = s.split(', ');
    return { date: new Date(datePart + 'T12:00:00'), hour: parseInt(timePart) };
  }

  function nextDispatchDay(tzDate, tzHour, cutoff, shipDays, holidays) {
    const d = new Date(tzDate);
    if (tzHour >= cutoff) d.setDate(d.getDate() + 1);
    while (true) {
      const dow = d.getDay();
      const iso = d.toISOString().slice(0, 10);
      if (dow === 0 || (shipDays === 'mon-fri' && dow === 6) || holidays.has(iso)) {
        d.setDate(d.getDate() + 1);
        continue;
      }
      return d;
    }
  }

  const EMERALD = '#047857';

  function fmtLocale(date, lang) {
    return date.toLocaleDateString(lang === 'fr' ? 'fr-FR' : lang === 'es' ? 'es-ES' : 'en-GB', {
      weekday: 'long', day: 'numeric', month: 'long'
    });
  }

  function formatDate(date, lang) {
    return '<strong style="color:' + EMERALD + '">' + fmtLocale(date, lang) + '</strong>';
  }

  function formatDateBold(date, lang) {
    return '<strong>' + fmtLocale(date, lang) + '</strong>';
  }

  function formatDateShort(date) {
    const d = String(date.getDate()).padStart(2, '0');
    const m = String(date.getMonth() + 1).padStart(2, '0');
    return d + '/' + m;
  }

  function addCalendarDays(start, days) {
    const d = new Date(start);
    d.setDate(d.getDate() + days);
    if (d.getDay() === 0) d.setDate(d.getDate() + 1); // skip Sunday
    return d;
  }

  function isTomorrow(date) {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    return date.toDateString() === tomorrow.toDateString();
  }

  /* ──────────────────────────────────────────────────────────────
     Pure ETA computation — single source of truth.
     Used by the <delivery-eta> element (PDP) AND the cart refresh.
     cfg: { country, lang, metal, stock, cutoff, leadMin, leadMax,
            prep, preorder, holidays:[] }
     Returns { message, propertyValue }.
     ────────────────────────────────────────────────────────────── */
  function computeEta(cfg, now) {
    const country = resolveCountry(cfg.country);
    const lang = cfg.lang || 'en';
    const metal = cfg.metal || 'unknown';
    const stock = cfg.stock;
    const cutoff = parseInt(cfg.cutoff) || 4;
    const preorderDate = cfg.preorder;
    const customHolidays = Array.isArray(cfg.holidays) ? cfg.holidays.filter(Boolean) : [];
    const t = I18N[lang] || I18N.en;

    now = now || new Date();
    const year = now.getFullYear();
    const frHolidays = new Set([
      ...frenchHolidays(year),
      ...frenchHolidays(year + 1),
      ...customHolidays
    ]);

    const isDomTom = DOM_TOM.has(country);
    const isEU = EU_COUNTRIES.has(country);
    const isFR = country === 'FR';
    const isGoldIntl = metal === 'gold' && !isFR && !isEU && !isDomTom;
    const shipDays = (isEU || isFR) ? 'mon-fri' : 'mon-sat';

    /* Dispatch: Dubai (9h) for gold intl, Paris (cutoff setting) for everything else */
    const tz = isGoldIntl ? 'Asia/Dubai' : 'Europe/Paris';
    const effectiveCutoff = isGoldIntl ? 9 : cutoff;
    const holidays = isGoldIntl ? new Set(customHolidays) : frHolidays;
    const { date: tzToday, hour: tzHour } = nowInTz(tz);
    const dispatchDay = nextDispatchDay(tzToday, tzHour, effectiveCutoff, shipDays, holidays);

    let message = '';
    let propertyValue = '';
    const fl = flag(country);
    const prefix = fl ? fl + '  ' : '';

    if (stock === 'out_of_stock') {
      /* ── OUT OF STOCK ── */
      if (metal === 'gold') {
        if (isEU) {
          /* Fabrication depuis Paris : fenêtre artisanale + transit du pays (0 pour FR) */
          const min = parseInt(cfg.leadMin) || 21;
          const max = parseInt(cfg.leadMax) || 30;
          const transit = isFR ? 0 : (TRANSIT[country] || 2);
          const dateMin = addCalendarDays(now, min + transit);
          const dateMax = addCalendarDays(now, max + transit);
          message = t.artisanal.replace('{min}', formatDate(dateMin, lang)).replace('{max}', formatDate(dateMax, lang));
          propertyValue = `${formatDateShort(dateMin)} – ${formatDateShort(dateMax)}`;
        } else if (isDomTom) {
          const prep = parseInt(cfg.prep) || 5;
          const transitMin = 3, transitMax = 5;
          const dateMin = addCalendarDays(now, prep + transitMin);
          const dateMax = addCalendarDays(now, prep + transitMax);
          const name = DOM_TOM_NAMES[country] || country;
          message = prefix + t.gold_oos_domtom.replace('{name}', name).replace('{min}', formatDate(dateMin, lang)).replace('{max}', formatDate(dateMax, lang));
          propertyValue = `${formatDateShort(dateMin)} – ${formatDateShort(dateMax)}`;
        } else {
          const prep = parseInt(cfg.prep) || 5;
          const transit = TRANSIT[country] || 3;
          const totalDays = prep + (typeof transit === 'object' ? transit.standard : transit);
          const deliveryDate = addCalendarDays(tzToday, totalDays);
          message = prefix + t.gold_oos_dhl.replace('{date}', formatDate(deliveryDate, lang));
          propertyValue = formatDateShort(deliveryDate);
        }
      } else {
        /* Silver/Vermeil out of stock → preorder */
        if (preorderDate) {
          const pd = new Date(preorderDate + 'T00:00:00');
          message = t.preorder.replace('{date}', formatDate(pd, lang));
          propertyValue = formatDateShort(pd);
        }
      }
    } else {
      /* ── IN STOCK ── */
      if (isFR) {
        const carrier = { shipDays: 'mon-sat', holidays: new Set() };
        const expressDelivery = addBusinessDays(dispatchDay, TRANSIT.FR.express, carrier);
        const standardDelivery = addBusinessDays(dispatchDay, TRANSIT.FR.standard, carrier);
        const expressTomorrow = isTomorrow(expressDelivery);
        const expressLine = expressTomorrow ? t.tomorrow : t.express.replace('{date}', formatDate(expressDelivery, lang));
        const standardLine = t.standard.replace('{date}', formatDateBold(standardDelivery, lang));
        const deliveredBy = metal === 'gold' ? t.gold_delivered_by : t.delivered_by;
        message = deliveredBy + '\n' + expressLine + '\n' + standardLine;
        propertyValue = formatDateShort(expressDelivery) + '-' + formatDateShort(standardDelivery);
      } else if (isDomTom) {
        const transitMin = 3, transitMax = 5;
        const dateMin = addBusinessDays(dispatchDay, transitMin, { shipDays: 'mon-sat', holidays: new Set() });
        const dateMax = addBusinessDays(dispatchDay, transitMax, { shipDays: 'mon-sat', holidays: new Set() });
        const name = DOM_TOM_NAMES[country] || country;
        message = prefix + t.domtom_range.replace('{name}', name).replace('{min}', formatDate(dateMin, lang)).replace('{max}', formatDate(dateMax, lang));
        propertyValue = `${formatDateShort(dateMin)} – ${formatDateShort(dateMax)}`;
      } else {
        const transit = TRANSIT[country] || 3;
        const transitDays = typeof transit === 'object' ? transit.standard : transit;
        const deliveryDate = addBusinessDays(dispatchDay, transitDays, { shipDays: 'mon-sat', holidays: new Set() });
        const dhlDelivery = metal === 'gold' ? t.gold_dhl_delivery : t.dhl_delivery;
        message = prefix + dhlDelivery.replace('{date}', formatDate(deliveryDate, lang));
        propertyValue = formatDateShort(deliveryDate);
      }
    }

    const carrier = CARRIER_OVERRIDE[country];
    if (carrier && message) message = message.replace('DHL', carrier);

    return { message, propertyValue };
  }

  /* ── Main custom element ── */
  class DeliveryEta extends HTMLElement {
    connectedCallback() {
      this.compute();
      this._observer = new MutationObserver(() => this.compute());
      this._observer.observe(this, { attributes: true });
    }

    disconnectedCallback() {
      this._observer?.disconnect();
    }

    compute() {
      const cfg = {
        country: this.dataset.country,
        lang: this.dataset.lang || 'en',
        metal: this.dataset.metal || 'unknown',
        stock: this.dataset.stock,
        cutoff: this.dataset.cutoff,
        leadMin: this.dataset.leadGoldMin,
        leadMax: this.dataset.leadGoldMax,
        prep: this.dataset.goldIntlPrep,
        preorder: this.dataset.preorderDate,
        holidays: this.dataset.holidays ? this.dataset.holidays.split(',').map(s => s.trim()) : []
      };
      const { message, propertyValue } = computeEta(cfg, new Date());

      /* Render */
      const msgEl = this.querySelector('.delivery-eta__message');
      if (msgEl) {
        msgEl.innerHTML = message.split('\n').map(l => `<span>${l}</span>`).join('<br>');
        msgEl.style.display = message ? '' : 'none';
      }
      const input = this.querySelector('[data-delivery-eta-input]');
      if (input) input.value = propertyValue;

      /* Persist a language-agnostic context so the cart can recompute the
         date later (dates go stale between add-to-cart and checkout). */
      const ctxInput = this.querySelector('[data-delivery-eta-ctx]');
      if (ctxInput) {
        ctxInput.value = JSON.stringify({
          metal: cfg.metal, stock: cfg.stock, cutoff: cfg.cutoff || '',
          leadMin: cfg.leadMin || '', leadMax: cfg.leadMax || '',
          prep: cfg.prep || '', preorder: cfg.preorder || '',
          holidays: cfg.holidays.join(',')
        });
      }

      this.style.display = message ? '' : 'none';
    }
  }

  if (!customElements.get('delivery-eta')) {
    customElements.define('delivery-eta', DeliveryEta);
  }

  /* ── Listen for variant changes (Prestige theme event) ── */
  document.addEventListener('variant:change', (e) => {
    const section = e.target.closest('[id^="shopify-section-"]') || e.target.closest('.product');
    if (!section) return;
    const el = section.querySelector('delivery-eta');
    if (!el) return;

    const variant = e.detail?.variant;
    if (!variant) return;

    /* Re-detect metal from variant title */
    const title = (variant.title || '').toLowerCase();
    let metal = 'unknown';
    if (title.includes('vermeil')) metal = 'silver';
    else if (title.includes('argent') || title.includes('silver') || title.includes('plata')) metal = 'silver';
    else if (title.includes('or ') || title.includes('or,') || title.includes('gold') || title.includes('oro') || title.includes('platine') || title.includes('platinum')) metal = 'gold';
    else if (variant.sku) {
      const parts = variant.sku.split('-');
      if (parts.length >= 3) {
        const letter = parts[2].slice(-1).toUpperCase();
        if ('AB'.includes(letter)) metal = 'silver';
        else if ('DEFJKLP'.includes(letter)) metal = 'gold';
      }
    }

    /* Update stock status using window.variantInventory (set in buy-buttons.liquid) */
    if (!variant.available) {
      el.style.display = 'none';
      return;
    }
    const inventoryQty = window.variantInventory && window.variantInventory[variant.id];
    const stock = (inventoryQty > 0 || inventoryQty === undefined) ? 'in_stock' : 'out_of_stock';

    el.dataset.preorderDate = (window.variantPreorderDate && window.variantPreorderDate[variant.id]) || '';
    el.dataset.metal = metal;
    el.dataset.stock = stock;
    el.dataset.variantId = variant.id;
    el.style.display = '';
    /* MutationObserver will trigger compute() via attribute change */
  });

  /* ──────────────────────────────────────────────────────────────
     Cart refresh — recompute stored delivery dates on the cart page.
     A date captured at add-to-cart goes stale if the customer returns
     days later. We recompute with the same engine + the current country,
     update the visible date, and patch the stored line item property so
     the checkout / confirmation email stay correct.
     ────────────────────────────────────────────────────────────── */
  async function refreshCartEta() {
    const spans = document.querySelectorAll('[data-eta-cart]');
    if (!spans.length) return;

    let cartLines = null;
    try {
      cartLines = (await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json())).items || [];
    } catch (e) {
      return; /* offline / cart unavailable → leave stored value */
    }
    const byKey = {};
    cartLines.forEach(it => { byKey[it.key] = it; });

    for (const span of spans) {
      let ctx;
      try { ctx = JSON.parse(span.dataset.ctx || '{}'); } catch (e) { continue; }
      if (!ctx || !ctx.stock) continue; /* no context stored (old cart) → skip */

      const cfg = {
        country: span.dataset.country,
        lang: span.dataset.lang || 'en',
        metal: ctx.metal,
        stock: ctx.stock,
        cutoff: ctx.cutoff,
        leadMin: ctx.leadMin,
        leadMax: ctx.leadMax,
        prep: ctx.prep,
        preorder: ctx.preorder,
        holidays: ctx.holidays ? String(ctx.holidays).split(',').map(s => s.trim()) : []
      };
      const { propertyValue } = computeEta(cfg, new Date());
      const fresh = (propertyValue || '').trim();
      const stored = (span.textContent || '').trim();
      if (!fresh || fresh === stored) continue;

      /* Update the visible date immediately */
      span.textContent = fresh;

      /* Patch the stored line item property (keep all other properties) */
      const line = byKey[span.dataset.lineKey];
      const label = span.dataset.label;
      if (!line || !label) continue;
      const props = Object.assign({}, line.properties || {});
      props[label] = fresh;
      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: span.dataset.lineKey, properties: props })
        });
      } catch (e) { /* visible date already refreshed; ignore patch failure */ }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshCartEta);
  } else {
    refreshCartEta();
  }
})();
